import type {
  IProductCategory,
  IProductCategoryOverview,
  IProductCategoryParentChildObject,
} from './../types/product/models'
import { httpGet, httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId } from '~/types/models'

const apiEntityPath = '/api/productcategories'

export async function getProductCategories({ apiPath = apiEntityPath } = {}) {
  const callingMn = getProductCategories.name
  return httpGet<IProductCategory[]>({ callingMn, apiPath })
}

export async function getProductCategoryOverview(id: string) {
  const callingMn = getProductCategoryOverview.name
  const apiPath = `${apiEntityPath}/${id}/overview`
  return httpGet<IProductCategoryOverview>({ callingMn, apiPath })
}

export async function getProductSubcategoriesForProductCategory(id: string) {
  const overview = await getProductCategoryOverview(id)
  return overview.productSubcategories.map(
    (productSubcategory) => productSubcategory
  )
}

export async function getProductCategoryParentChildObject(id: string) {
  const fn = `[services/productCategories.ts] ${getProductCategoryParentChildObject.name} |`
  console.debug(`${fn} calling getProductCategoryOverview`)
  const overview = await getProductCategoryOverview(id)
  const parentChildObject: IProductCategoryParentChildObject = {
    parent: {
      entityName: 'productCategory',
      object: {
        id: overview.productCategory.id,
        label: overview.productCategory.descr,
      },
    },
    children: {
      entityName: 'productSubcategory',
      entityDataItems: overview.productSubcategories,
    },
  }
  return parentChildObject
}

export async function createProductCategory(entity: IProductCategory) {
  const callingMn = createProductCategory.name
  const apiPath = apiEntityPath
  return httpPost<IProductCategory>({ callingMn, apiPath, entity })
}

export async function updateProductCategory(
  entityData: Partial<IProductCategory>,
  id: TEntityId
) {
  const callingMn = updateProductCategory.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialIProductCategory = Partial<IProductCategory>
  return httpPatchMerge<TPartialIProductCategory>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteProductCategory(entityData: IProductCategory) {
  const callingMn = deleteProductCategory.name
  const apiPath = apiEntityPath
  return httpDelete({
    callingMn,
    apiPath,
    entityData,
  })
}
